import { useState } from "react";
import { CalendarClock, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

const toLocalInput = (iso) => {
  const d = iso ? new Date(iso) : new Date(Date.now() + 3600000);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const ScheduleControl = ({ mediaId, publishAt, onChange }) => {
  const [when, setWhen] = useState(toLocalInput(publishAt));
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/media/${mediaId}/schedule`, { publish_at: new Date(when).toISOString() });
      onChange(data.publish_at);
      toast.success(`Scheduled for ${new Date(data.publish_at).toLocaleString()}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Couldn't schedule");
    } finally { setBusy(false); }
  };
  const cancel = async () => {
    setBusy(true);
    try { await api.delete(`/media/${mediaId}/schedule`); onChange(null); toast.success("Schedule cancelled"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="schedule-control" className="mt-4 bg-[#0A0A0A] border border-white/10 rounded-2xl p-4">
      <p className="flex items-center gap-2 font-heading uppercase tracking-widest text-xs text-white mb-3">
        <CalendarClock size={14} className="text-[#00E5FF]" /> {publishAt ? "Scheduled to publish" : "Schedule publishing"}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <input data-testid="schedule-datetime-input" type="datetime-local" value={when} min={toLocalInput(new Date().toISOString())}
          onChange={(e) => setWhen(e.target.value)}
          className="bg-[#141414] border border-white/10 rounded-lg px-3 py-2 text-sm text-white [color-scheme:dark] focus:border-[#00E5FF] outline-none" />
        <button data-testid="schedule-save-btn" onClick={save} disabled={busy || !when}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#00E5FF] text-black font-heading uppercase tracking-widest text-[11px] hover:bg-white transition-colors disabled:opacity-50">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <CalendarClock size={13} />} {publishAt ? "Update" : "Schedule"}
        </button>
        {publishAt && (
          <button data-testid="schedule-cancel-btn" onClick={cancel} disabled={busy}
            className="flex items-center gap-1 px-3 py-2 rounded-full border border-white/10 text-[#A1A1AA] hover:text-[#FF2A5F] hover:border-[#FF2A5F] font-mono text-[11px] transition-colors">
            <X size={12} /> Cancel
          </button>
        )}
      </div>
      <p className="font-mono text-[10px] text-[#52525B] mt-2">Goes live automatically within 15 minutes of the chosen time.</p>
    </div>
  );
};
